// src/pages/Media.js
import React from "react";

function Media() {
  return (
    <div style={{ padding: "20px" }}>
      <h2>Media</h2>
      <p>Placeholder for media content</p>
    </div>
  );
}

export default Media;